import { qcAxios } from '../../../../../api/axiosQcClient';
import { normalizeAssignments } from '../../../../../services/qc/qcTaskAssignmentsService';

const API_PREFIX = '/api';

export async function getAssignedRequests({
  reqStatus,
  page,
  limit,
  batchId,
  workflowId,
  filters,
  sortBy,
  sortDirection,
}) {
  const { data } = await qcAxios.get(
    `${API_PREFIX}/assignmentData/getAssignedRequests`,
    {
      params: {
        workflowId,
        reviewer: true,
        batchId,
        reqStatus,
        userSpecific: true,
        page,
        limit,
        sortDirection: sortDirection ?? 'ASC',
        sortBy: sortBy ?? 'file_name',
        language: filters?.language ?? '',
        district: filters?.district ?? '',
        state: filters?.state ?? '',
        duration: filters?.duration ?? '',
        file_name: filters?.file_name ?? '',
        source_file: filters?.source_file ?? '',
        search: filters?.search ?? '',
      },
    },
  );
  return normalizeAssignments(data);
}
